import { StoreTitle } from "../../components/hashTag/StoreTitle";
import ProductListSection3 from "../../components/hashTag/ProductListSection3";

export default function HashTagStore() {
    return (
        <div className="h-full bg-white dark:bg-black relative overflow-hidden">
            <StoreTitle />
            <div className="mt-1 absolute w-full h-[-webkit-fill-available] overflow-scroll no-scrollbar">
                <ProductListSection3 />
            </div>
        </div>
    );
}


